const TOKEN_KEY = "token";
const USER_KEY = "user";
const SESSION_EXPIRY_KEY = "auth_session_expires_at";
const SESSION_TIMEOUT = 8 * 60 * 60 * 1000;

const decodeJwtPayload = (token) => {
  try {
    const parts = token?.split(".");
    if (!token || parts?.length !== 3) return null;
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(base64.length + (4 - (base64.length % 4)) % 4, "=");
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
};

const clearSessionStorage = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(SESSION_EXPIRY_KEY);
};

export const TokenManager = {
  getToken() {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) return null;

    const expiresAt = Number(localStorage.getItem(SESSION_EXPIRY_KEY));
    if (!expiresAt || Date.now() >= expiresAt) {
      clearSessionStorage();
      return null;
    }

    const payload = decodeJwtPayload(token);
    if (payload?.exp && Date.now() >= payload.exp * 1000) {
      clearSessionStorage();
      return null;
    }

    return token;
  },

  setToken(token) {
    console.log("Setting token in localStorage:", token ? "Token present" : "No token");
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(SESSION_EXPIRY_KEY, String(Date.now() + SESSION_TIMEOUT));
    console.log("Token stored successfully. Verifying...");
    const stored = localStorage.getItem(TOKEN_KEY);
    console.log("Stored token verification:", stored ? "Token found" : "Token not found");
  },

  touchSession() {
    if (!localStorage.getItem(TOKEN_KEY)) return false;
    localStorage.setItem(SESSION_EXPIRY_KEY, String(Date.now() + SESSION_TIMEOUT));
    return true;
  },

  getSessionExpiry() {
    const value = Number(localStorage.getItem(SESSION_EXPIRY_KEY));
    return Number.isFinite(value) && value > 0 ? value : null;
  },

  clearToken() {
    clearSessionStorage();
  },

  clearSession() {
    clearSessionStorage();
  },

  isLoggedIn() {
    return !!this.getToken();
  },

  getUserRole() {
    const payload = decodeJwtPayload(this.getToken());
    return payload?.role || null;
  },

  getUsername() {
    const payload = decodeJwtPayload(this.getToken());
    return payload?.sub || null;
  },

  getPlan() {
    const payload = decodeJwtPayload(this.getToken());
    return payload?.plan || localStorage.getItem('user_plan') || 'basic';
  },
};

export { SESSION_EXPIRY_KEY, SESSION_TIMEOUT };
